import useApi from 'hooks/useApi';
import useUserApi from 'hooks/UserApi/useUserApi';
import Script from 'next/script';
import { useCmsData } from './cms';

const ZendeskWidget = () => {
  const { user } = useUserApi();
  const apiClient = useApi();
  const { generalSettings } = useCmsData();
  const displayZendesk = Boolean(user && generalSettings?.zendeskMessengerId);

  const onLoad = () => {
    if (!window.zE) {
      return;
    }

    window.zE('messenger:set', 'zIndex', 50);

    // Login user
    window.zE(
      'messenger',
      'loginUser',
      (callback) => {
        apiClient.user.apiUserzendeskjwtGet().then((res) => {
          callback(res.data.jwt!);
        });
      },
      (error) => console.error(error),
    );

    if (user) {
      // Set metadata conversation fields
      window.zE('messenger:set', 'conversationFields', [
        { id: '20254629318802', value: user.email! },
        { id: '20209309945362', value: user.uniqueId! },
        { id: '20209196215058', value: user.lastName! },
        { id: '20209261300626', value: user.firstName! },
      ]);
    }
  };

  if (!displayZendesk) {
    return null;
  }

  return (
    <Script
      id="ze-snippet"
      onLoad={onLoad}
      src={`https://static.zdassets.com/ekr/snippet.js?key=${generalSettings.zendeskMessengerId}`}
    />
  );
};

export default ZendeskWidget;
